<section id="faqSectionDonateCarPage" class="mb-8 lg:mb-16">
  <div class="py-8 px-3 mx-auto max-w-screen-xl sm:py-16 lg:px-6">
    <h2 class="text-6xl tracking-tight font-bold font-tektur text-mainColor"
        [innerText]="title"></h2>
    <div class="flex w-[54%] pt-8 max-xl:w-full">
      <div class="[&>div]:font-tektur [&>div>h3]:font-semibold [&>div>h3]:text-3xl [&>div>h3]:text-mainColor [&>div>p]:text-mainColor">
        <div class="mb-10">
          <h3 class="flex items-center mb-4" i18n>
            How can I donate my car to Ukraine?
          </h3>
          <p i18n>
            You can donate car to Ukraine with us. Please fill up the form and we’ll get back to you within 24 hours.
            We focus mainly on pickup trucks and 4x4 cars, but other means of transportation such as vans, and civilian
            cars are accepted as soldiers also move around and have different tasks for which wheels are needed.
          </p>
        </div>
        <div class="mb-10">
          <h3 class="flex items-center mb-4" i18n>
            How to donate to Ukraine army?
          </h3>
          <p i18n>
            You can donate to Ukraine army with Car for Ukraine, where we focus specifically on cars for the army.
            Pickup trucks, 4x4 cars, vans, etc. If you wish to donate your car, please fill up the form, and we’ll
            get back to you within 24 hours.<br><br>
            To support the army financially, you can donate here supporting
            our initiative or check out Come Back Alive organization who helps Ukraine with various projects.
          </p>
        </div>
        <div class="mb-10">
          <h3 class="flex items-center mb-4" i18n>
            How to donate a car to charity?
          </h3>
          <p i18n>
            You can donate a car to charity with Car for Ukraine. We focus on providing
            the Ukrainian army with means of transportation which includes both lethal and humanitarian needs,
            such as evacuating people from war zones, bringing food and water, etc.
          </p>
        </div>
        <div class="mb-10">
          <h3 class="flex items-center mb-4" i18n>
            What vehicles do you need?
          </h3>
          <p  i18n>We focus on mobile combat groups who need 4-wheel drive diesel trucks with
            2.0l engines or more. These are some of the best options: Toyota Hilux / Tundra, Mitsubishi L200,
            Ford Ranger, Nissan Navara/KingCab, Isuzu D-Max, Mazda BT-50 / Mazda B2500. Besides pickup trucks,
            4x4 cars and vans as well as simple civilian vehicles are required too for various missions, e.g. aid
            delivery,
            food supplies, etc.
          </p>
        </div>
        <div class="mb-10">
          <h3 class="flex items-center mb-4" i18n>
            Do I have to bring the car personally to Ukraine?
          </h3>
          <p i18n>
            No, we can pickup your car anywhere in Europe or UK. But we’ll be also happy to assist you with all
            the paperwork if you decide to come in person.
        </div>
      </div>
    </div>
  </div>
</section>
